import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';

@Pipe({
  name: 'translate',
  pure: true
})
export class TranslatePipe implements PipeTransform {
  constructor( private translate: TranslateService ) { }

  transform(value: string, args: any[]): any {
    if (!value) return;
    return this.translate.instant(value.toUpperCase(), args);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/i18n/translate.pipe.ts